import React from 'react';
import AreaChartRatioCard from 'src/App/Dashboards/Market/Components/Cards/AreaChartRatio';

const InternationDomesticGuestsCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  userTailorMarketAccess,
  warningTextComponent,
  domesticVsInternationalGraphRef,
  setSelectedGraphExportDetails,
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  userTailorMarketAccess: boolean;
  warningTextComponent: any;
  domesticVsInternationalGraphRef: any;
  setSelectedGraphExportDetails: any;
}) => {
  const demoData = {
    domestic: {
      '2023-04-30': 10.5,
      '2023-06-30': 12.5,
      '2023-07-31': 16.7,
      '2023-08-31': 21.4,
      '2023-09-30': 30.8,
      '2023-10-31': 12.5,
      '2023-11-30': 7.1,
      '2023-12-31': 13,
      '2024-01-31': 8.3,
      '2024-02-29': 5.4,
      '2024-03-31': 13.3,
      '2024-04-30': 18.5,
      '2024-05-31': 12,
      '2024-10-31': 6.7,
      '2024-11-30': 7.4,
      '2024-12-31': 12.5,
      '2025-01-31': 10,
      '2025-02-28': 7.4,
      '2025-03-31': 12.5,
    },
    international: {
      '2023-04-30': 89.5,
      '2023-06-30': 87.5,
      '2023-07-31': 83.3,
      '2023-08-31': 78.6,
      '2023-09-30': 69.2,
      '2023-10-31': 87.5,
      '2023-11-30': 92.9,
      '2023-12-31': 87,
      '2024-01-31': 91.7,
      '2024-02-29': 94.6,
      '2024-03-31': 86.7,
      '2024-04-30': 81.5,
      '2024-05-31': 88,
      '2024-10-31': 93.3,
      '2024-11-30': 92.6,
      '2024-12-31': 87.5,
      '2025-01-31': 90,
      '2025-02-28': 92.6,
      '2025-03-31': 87.5,
    },
  };
  return (
    <AreaChartRatioCard
      title="Domestic vs International Guests"
      data={isDisabled ? demoData : graph.data?.guest_origin?.history}
      tooltipContent={'Percentage of Domestic and International Guests booking'}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      userTailorMarketAccess={userTailorMarketAccess}
      parent="domestic_vs_intl_guests"
      warningTextComponent={warningTextComponent}
      graphRef={domesticVsInternationalGraphRef}
      setSelectedGraphExportDetails={setSelectedGraphExportDetails}
    />
  );
};

export default InternationDomesticGuestsCard;
